import { computed } from "vue";

export default {
  data() {
    return {
      isOwner: false,
      canRead: false,
      canWrite: false,
    };
  },
  created() {
    this.setPermissions();
  },
  computed: {
    hasPermission() {
      return this.isOwner || this.canWrite;
    },
  },
  provide() {
    return {
      isOwner: computed(() => this.isOwner),
      canRead: computed(() => this.canRead),
      canWrite: computed(() => this.canWrite),
      hasPermission: computed(() => this.hasPermission),
    };
  },
  methods: {
    setPermissions() {
      if (this.modelDT?.permissions) {
        this.isOwner = this.modelDT.permissions.ownership;

        if (this.modelDT.permissions?.capabilities) {
          this.canRead = this.modelDT.permissions.capabilities.canRead;
          this.canWrite = this.modelDT.permissions.capabilities.canWrite;
        }
      }
    },
  },
};
